import {setFixedStringAt} from 'util/StringUtil';
import {EvoAppsUserTO} from 'generated/JavaTO'

export const evoAppsUserToSerialID = function (user: EvoAppsUserTO, defaultUser: EvoAppsUserTO) {
	const isDefault = user.username === defaultUser.username && user.userGroup.id === defaultUser.userGroup.id;
	let id = setFixedStringAt("", user.username, 0, 8);
	id = setFixedStringAt(id, user.userGroup.id, 8, 8);
	id = setFixedStringAt(id, isDefault ? 1 : 0, 16, 1);
	return id;
}

export const parseEvoAppsUserSerialID = (serialid: string) => ({
	username: serialid.substring(0, 8).trim(),
	userGroup: serialid.substring(8, 16).trim(),
	reset: serialid.substring(16, 17).trim() === '1',
})